import React from "react";
import { cn } from "@edusogno/lib/utils";
import { t } from "i18next";

type Props = {
  label?: string;
  children?: React.ReactNode;
  isLastStep?: boolean;
  isLastStepComplete?: boolean;
};

const StepBox: React.FC<Props> = ({
  label,
  children,
  isLastStep,
  isLastStepComplete,
}) => (
  <div
    className={cn(
      "gap-1 flex flex-col items-center px-6 w-full bg-white/50 rounded-[15px] justify-center flex-[1_1_105px] ",
      {
        "bg-[--primary300]": children,
        "bg-[--primary]": isLastStepComplete,
      },
    )}
  >
    {children ? (
      children
    ) : (
      <div className={"flex flex-col justify-center gap-2 items-center"}>
        {isLastStep ? (
          <></>
        ) : (
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.5">
              <path
                d="M3.48438 8.49105C3.48438 8.29213 3.56339 8.10137 3.70404 7.96072C3.8447 7.82007 4.03546 7.74105 4.23438 7.74105H7.72738V4.24805C7.72738 4.04913 7.80639 3.85837 7.94705 3.71772C8.0877 3.57706 8.27846 3.49805 8.47738 3.49805C8.67629 3.49805 8.86705 3.57706 9.0077 3.71772C9.14836 3.85837 9.22738 4.04913 9.22738 4.24805V7.74105H12.7204C12.9193 7.74105 13.1101 7.82007 13.2507 7.96072C13.3914 8.10137 13.4704 8.29213 13.4704 8.49105C13.4704 8.68996 13.3914 8.88072 13.2507 9.02138C13.1101 9.16203 12.9193 9.24105 12.7204 9.24105H9.22738V12.734C9.22738 12.933 9.14836 13.1237 9.0077 13.2644C8.86705 13.405 8.67629 13.484 8.47738 13.484C8.27846 13.484 8.0877 13.405 7.94705 13.2644C7.80639 13.1237 7.72738 12.933 7.72738 12.734V9.24105H4.23438C4.03546 9.24105 3.8447 9.16203 3.70404 9.02138C3.56339 8.88072 3.48438 8.68996 3.48438 8.49105Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.79292 0.258781C6.90538 -0.0862605 10.0465 -0.0862605 13.1589 0.258781C14.9859 0.462781 16.4609 1.90178 16.6749 3.73878C17.0449 6.89578 17.0449 10.0848 16.6749 13.2418C16.4599 15.0788 14.9849 16.5168 13.1589 16.7218C10.0465 17.0668 6.90538 17.0668 3.79292 16.7218C1.96592 16.5168 0.490917 15.0788 0.276917 13.2418C-0.0923055 10.0849 -0.0923055 6.89569 0.276917 3.73878C0.490917 1.90178 1.96692 0.462781 3.79292 0.258781ZM12.9929 1.74878C9.99078 1.41602 6.96106 1.41602 3.95892 1.74878C3.40316 1.81044 2.88442 2.05766 2.48649 2.4505C2.08857 2.84334 1.83471 3.35886 1.76592 3.91378C1.41026 6.95475 1.41026 10.0268 1.76592 13.0678C1.83492 13.6225 2.08887 14.1378 2.48678 14.5305C2.88468 14.9231 3.40331 15.1702 3.95892 15.2318C6.93592 15.5638 10.0159 15.5638 12.9929 15.2318C13.5483 15.17 14.0667 14.9228 14.4644 14.5302C14.8622 14.1375 15.116 13.6224 15.1849 13.0678C15.5406 10.0268 15.5406 6.95475 15.1849 3.91378C15.1158 3.35937 14.8618 2.84443 14.4642 2.452C14.0665 2.05958 13.5482 1.81256 12.9929 1.75078"
                fill="white"
              />
            </g>
          </svg>
        )}
        <p
          className={cn("text-xs font-medium text-white/50", {
            "text-white font-semibold": isLastStepComplete,
          })}
        >
          {isLastStep
            ? isLastStepComplete
              ? "Thanks and enjoy your lesson!"
              : t("one_to_one.stepbox.last_step", { defaultValue: "Last step" })
            : label}
        </p>
      </div>
    )}
  </div>
);
export default StepBox;
